export default __webpack_public_path__ + "static/media/node-1-thumbnail.6e860f59.jpg";